import { Button, Link } from "@mui/material";
import type { FC } from "react";

export interface SearchForThisColorCodeButtonProps {
  finalColorCode?: string;
}

export const SearchForThisColorCodeButton: FC<
  SearchForThisColorCodeButtonProps
> = ({ finalColorCode }) => {
  return (
    <Link
      href={`/search?finalColorCode=${finalColorCode}&colorSystem=covestro_color_code`}
      target="_blank"
      referrerPolicy="no-referrer"
    >
      {finalColorCode !== undefined && (
        <Button
          disabled={finalColorCode === undefined}
          sx={{ m: 0, p: 0, height: "auto", textAlign: "start" }}
          size="small"
        >
          Show all materials with this color code
        </Button>
      )}
    </Link>
  );
};
